(function() {
    'use strict';

    angular
        .module('quantixApp')
        .factory('AlertMasterService', AlertMasterService);

    AlertMasterService.$inject = ['$resource'];

    function AlertMasterService($resource) {
    	
    	var factory = {}; 

    	factory.setCompanyAlert =  $resource(
						'api/companyAlert/setAlert',
						{
							companyCode : '@companyCode',
							actionFlag : '@actionFlag'
						},
						{
							'setAlert' : {
								method : 'POST',								
								transformResponse : function(data) {
									data = angular.fromJson(data);	
 									return data;											
								}
							}
						});
    	
    	factory.removeCompanyAlert =  $resource(
				'api/companyAlert/removeAlert',
				{
					companyCode : '@companyCode'					
				},
				{
					'removeAlert' : {
						method : 'POST',								
						transformResponse : function(data) {
  	            data = angular.fromJson(data);											
							return data;											
						}
					}
				});	
   
        return factory;
    }
})();
